import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { FadeUp } from '../ui/FadeUp';
import { CTAButton } from '../ui/CTAButton';
export function InvestmentSection() {
  const valueItems = [{
    label: 'Sesiones individuales de coaching',
    price: '+$45.000'
  }, {
    label: 'Formación en regulación emocional',
    price: '+$25.000'
  }, {
    label: 'Guías prácticas y audios guiados',
    price: '+$18.000'
  }, {
    label: 'Herramientas de higiene energética',
    price: '+$22.000'
  }];
  const includes = ['Sistema completo en 3 Fases', '5 Bonos exclusivos incluidos', 'Acceso inmediato y de por vida', 'Uso ilimitado en cualquier dispositivo'];
  return <SectionWrapper bgColor="sand" id="investment" data-id="element-131">
      <FadeUp data-id="element-132">
        <div className="text-center mb-10" data-id="element-133">
          <h2 className="font-serif text-[clamp(28px,8vw,40px)] mb-4" data-id="element-134">
            Seguir reaccionando
            <br data-id="element-135" />
            también tiene un costo.
          </h2>
          <p className="text-[14px] text-muted leading-[1.7]" data-id="element-136">
            No siempre se ve en dinero. Pero se siente en tu energía.
          </p>
        </div>
      </FadeUp>

      <FadeUp delay={0.1} data-id="element-137">
        <div className="bg-white rounded-[10px] overflow-hidden mb-7 shadow-[0_2px_20px_rgba(0,0,0,0.05)]" data-id="element-138">
          {valueItems.map((item, index) => <div key={index} className="flex justify-between items-center p-[14px_20px] text-[13px] border-b border-sand last:border-0" data-id="element-139">
              <span className="text-charcoal" data-id="element-140">{item.label}</span>
              <span className="text-muted font-medium" data-id="element-141">{item.price}</span>
            </div>)}
          <div className="bg-sand p-[16px_20px] flex justify-between items-center text-[14px] font-medium" data-id="element-142">
            <span data-id="element-143">Valor estimado total</span>
            <span className="font-serif text-[22px] text-muted line-through" data-id="element-144">
              $70.000
            </span>
          </div>
        </div>
      </FadeUp>

      <FadeUp delay={0.2} data-id="element-145">
        <div className="bg-plum-deep rounded-[14px] p-[36px_24px] text-center text-white relative overflow-hidden" data-id="element-146">
          <div className="absolute -top-[60px] -right-[60px] w-[180px] h-[180px] rounded-full bg-white/5 pointer-events-none" data-id="element-147" />

          <p className="text-[10px] tracking-[0.2em] uppercase text-gold-light mb-1" data-id="element-148">
            Valor real del sistema
          </p>
          <p className="text-[11px] tracking-[0.15em] uppercase text-white/40 mb-5" data-id="element-149">
            Precio especial de lanzamiento
          </p>

          <div className="font-serif text-[72px] font-light leading-none text-white mb-1" data-id="element-150">
            <span className="text-[18px] text-white/50 align-super font-sans font-light" data-id="element-151">
              $
            </span>
            19.990
          </div>
          <p className="text-[12px] text-white/40 tracking-[0.1em] mb-1.5" data-id="element-152">
            ARS
          </p>

          <p className="text-[13px] text-gold-light mb-7 font-medium" data-id="element-153">
            Ahorrás más de $50.000 hoy
          </p>

          <ul className="text-left mb-7 space-y-0" data-id="element-154">
            {includes.map((item, index) => <li key={index} className="text-[13px] text-white/80 py-2 border-b border-white/5 flex items-center gap-2.5" data-id="element-155">
                <span className="text-gold-light text-[12px] flex-shrink-0" data-id="element-156">
                  ✓
                </span>
                {item}
              </li>)}
          </ul>

          <a href="https://checkout.pro-mind.solutions/checkouts/cn/hWNAxKDnoY7mzFOuDC4SI1WE/es-ar?_r=AQABGqTnZJyZD3IbAB-NySxfbgYwLfinNd204o62SjZgPkg&preview_theme_id=157919314137" className="block w-full bg-gold text-plum-deep border-none p-[20px_24px] font-sans text-[15px] font-semibold tracking-[0.03em] text-center rounded-[6px] mb-3.5 transition-transform active:scale-[0.98] relative overflow-hidden group" data-id="element-157">
            <span className="relative z-10" data-id="element-158">Quiero recuperar mi eje →</span>
            <div className="absolute inset-0 z-0 bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.15),transparent)] bg-[length:200%_100%] animate-shimmer" data-id="element-159" />
          </a>

          <p className="text-[11px] text-white/35 tracking-[0.05em]" data-id="element-160">
            Pago único · Acceso seguro · Garantía de satisfacción
          </p>
        </div>
      </FadeUp>
    </SectionWrapper>;
}